import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../userContext"
import ResidencyForm from "./components/residencyForm"
import { fetchResource } from "../../methods/fetchResource"
import { generateErrorMessage } from "../../methods/generateErrorMessage"

export default function Residency() {
	const [message, setMessage] = useState("")
	const [applicants, setApplicants] = useState([])
	const [applicantProgress, setApplicantProgress] = useState({})
	const userContext = useContext(UserContext)
	const navigate = useNavigate()

	useEffect(() => {
		async function fetchData() {
			try {
				let streetAddress = await fetchResource(`/api/situsAddress?parcelID=${userContext.parcelID}`)

				if (!streetAddress.success) {
					setMessage(generateErrorMessage(streetAddress.status))
					//document.getElementById("residencyMessage").scrollIntoView()
					return
				}

				document.getElementById("inputStreetAddress").value = streetAddress.result.address2

				let applicantList = await fetchResource(`/api/applicants/list?parcelID=${userContext.parcelID}`)

				if (!applicantList.success) {
					setMessage(generateErrorMessage(applicantList.status))
					//document.getElementById("residencyMessage").scrollIntoView()
					return
				}

				let applicantSet = {}
				applicantList.result.rows.forEach((applicant) => {
					applicantSet[applicant.applicant_id] = applicant.residency_valid
				})

				setApplicants(applicantList.result.rows)
				setApplicantProgress(applicantSet)
			}
			catch (error) {
				console.log(error)
				setMessage(generateErrorMessage(999))
				//document.getElementById("residencyMessage").scrollIntoView()
			}
		}

		fetchData()
	}, [userContext.parcelID])

	useEffect(() => {
		if (Object.keys(applicantProgress).length === 0) {
			return
		}

		let allValid = true
		Object.keys(applicantProgress).forEach((applicantId) => {
			if (!applicantProgress[applicantId]) {
				allValid = false
			}
		})

		if (allValid) {
			navigate("/exemptions")
		}
	}, [applicantProgress, navigate])

	function adjustSizeOfStreetAddress(event) {
		event.target.size = event.target.value.length
	}

	return (
		<div id="exemptions-portal--residency-check" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">Residency Check</h1>
					<div className="bg-navy text-light px-3 pt-3 pb-1 rounded">
						<div className="bg-navy-dark p-3 rounded mb-3">
							<div className="input-group mx-auto mb-3" style={{maxWidth: "650px"}}>
								<label
									htmlFor="inputStreetAddress"
									className="input-group-text"
								>
									Street Address:
								</label>
								<input
									id="inputStreetAddress"
									type="text"
									disabled
									required
									placeholder="Loading..."
									title="Your Street Address"
									onChange={adjustSizeOfStreetAddress}
									className="form-control"
								/>
							</div>
							<div className="bg-warning rounded text-dark p-3">
								<ul className="h5 m-0">
									<li>If the address above does not match what is on each person's driver license, you will not be able to continue.</li>
									<li>All applicants listed on this page must pass the residency check to continue.</li>
								</ul>
							</div>
						</div>
						<p className="bg-navy-dark p-3 rounded mb-3">
							Pursuant to
							{" "}
							<a
								href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&Search_String=&URL=0100-0199/0119/Sections/0119.071.html"
								target="_blank"
								rel="noreferrer noopener"
								className="text-warning"
							>
								section 119.071(5)(a) 2 and 3
							</a>
							{" "}
							and
							{" "}
							<a
								href="http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&URL=0100-0199/0196/Sections/0196.015.html"
								target="_blank"
								rel="noreferrer noopener"
								className="text-warning"
							>
								section 196.015
							</a>
							{" "}
							Florida Statutes, the Santa Rosa County Property Appraiser's Office is required to collect on each new application for exemption the Date of Birth, Driver License Number, and Social Security Number of the applicant and that of his or her spouse, if any, to verify their eligibility to receive exemptions.
						</p>
						<hr />
						{
							applicants.map((applicant) => (
								<div key={applicant.applicant_id} className="bg-navy-dark p-3 rounded mb-3">
									<ResidencyForm id={applicant.applicant_id} name={applicant.applicant_name}
										residencyValid={applicant.residency_valid} applicantProgressData={applicantProgress}
										setApplicantProgressData={setApplicantProgress} />
								</div>
							))
						}
						<h2 className={`bg-danger p-3 rounded ${message === "" ? "d-none" : ""}`}>
							<i className="fa-solid fa-circle-exclamation"></i> {message}
						</h2>
					</div>
				</div>
			</div>
		</div>
	)
}